import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms'; // Füge diese Zeile hinzu
import { CookieConsentService } from '../../services/cookie-consent.service';
import { NgOptimizedImage } from '@angular/common';
import { ImageService } from '../../services/image.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, FormsModule, NgOptimizedImage], // Füge FormsModule hier hinzu
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})

export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  footerEmail: string = '';

  constructor(
    private cookieService: CookieConsentService,
    public imageService: ImageService
  ) {}

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }

  subscribeToNewsletter(email: string): void {
    if (email && email.trim() !== '') {
      // Hier die Newsletter-Anmeldung verarbeiten
      console.log('Newsletter-Anmeldung aus Footer für:', email);
      
      // Feedback (könnte auch ein Toast oder eine andere Benachrichtigung sein)
      alert('Vielen Dank für deine Anmeldung zum Newsletter!');
      
      // Formular zurücksetzen
      this.footerEmail = '';
    }
  }

  showCookieBanner(){
    this.cookieService.showConsent()
  }
}